import axiosInstance from '../api/axios';

const GetDataVaga = async (                                     
                username,
                token,                 
                studyName,
                waveName,
                lineName,
                columnName,
                filters
            ) => {
                   
    const JSONselectedFilters = JSON.stringify(filters);
    const controller = new AbortController();

    // O TRY COMEÇA AQUI EM CIMA!
    try {
        const response = await axiosInstance.post("/tables/getdatavaga",
            {},
            {
                signal: controller.signal,
                params: {
                    username,
                    token,
                    studyName,
                    waveName,
                    lineName,
                    columnName,
                    JSONselectedFilters
                }
            });
        
        const result = await response.data;          
        controller.abort();     
        return result;
        
    } catch (err) {
        // Apanha qualquer erro de rede, timeout ou erro 500 do servidor
        console.error("ERRO [Tables, GetDataVaga]: Falha ao obter resultados da operação.", err);
        if (!err?.response) {
            alert("Falha de comunicação com o servidor ao obter os resultados. Por favor, contate o serviço técnico da DATA E.");
        }
        return null; // Devolvemos null para parar o spinner em caso de erro
    }
}

export default GetDataVaga;